import { Link, useParams, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Reveal from '@/components/Reveal';
import { COMING_SOON } from '@/constants/testIds';

const titleFromSlug = (slug) =>
  slug
    ? slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    : null;

export default function ComingSoon() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const isWomens = pathname.startsWith('/womens-design');
  const isMens = pathname.startsWith('/mens-bespoke');
  const houseLabel = isWomens ? 'VM by Vandana' : isMens ? 'Bombay Bespoke' : 'Bombay Bespoke';
  const accent = isWomens ? 'text-[hsl(var(--bb-emerald))]' : 'text-[hsl(var(--bb-gold-deep))]';
  const backTo = isWomens ? '/womens-design' : isMens ? '/mens-bespoke' : '/';
  const backLabel = isWomens ? 'Back to Women’s Design' : isMens ? 'Back to Men’s Bespoke' : 'Back to Home';

  return (
    <div
      data-testid={COMING_SOON.root}
      className="relative bg-[hsl(var(--bb-ivory))] min-h-[calc(100vh-88px)] flex items-center overflow-hidden"
    >
      <div className="bb-container py-24 md:py-36 text-center max-w-3xl">
        <Reveal>
          <div className="bb-eyebrow">{houseLabel}{slug ? ` · ${titleFromSlug(slug)}` : ''}</div>
        </Reveal>
        <Reveal delay={140}>
          <h1 className="bb-display text-6xl md:text-8xl mt-6 text-[hsl(var(--bb-text))] leading-[0.95]">
            This collection
            <br />
            is being <span className={`bb-italic ${accent}`}>curated.</span>
          </h1>
        </Reveal>
        <Reveal delay={260}>
          <p className="mt-8 text-[hsl(var(--bb-text-muted))] text-base md:text-lg leading-relaxed max-w-xl mx-auto">
            We are quietly preparing this collection in the atelier. In the meantime, you
            are warmly invited to book a private consultation — and we’ll share early
            references on request.
          </p>
        </Reveal>
        <Reveal delay={360}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-5">
            <Link
              to="/book-appointment"
              className="inline-flex items-center px-7 py-4 bg-[hsl(var(--bb-gold))] text-[hsl(var(--bb-charcoal))] uppercase tracking-[0.24em] text-[11px] font-medium hover:bg-[hsl(var(--bb-gold-deep))] transition-colors"
            >
              Book a consultation
            </Link>
            <Link
              to={backTo}
              data-testid={COMING_SOON.backHome}
              className="bb-link bb-link-reverse text-[hsl(var(--bb-text))] inline-flex items-center gap-2"
            >
              <ArrowLeft size={14} /> {backLabel}
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
